// extracted by mini-css-extract-plugin
module.exports =  {"link":"Integrations-module__link--fC"};